import { Component } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { AdministradorService } from 'src/app/services/administrador.service';
import { Producto } from "src/app/models/producto.interface";
@Component({
    selector: 'app-administrador-producto',
    templateUrl: './administrador-producto.component.html',
    styleUrls: ['./administrador-producto.component.scss']
})
export class AdministradorProductoComponent {
    producto!: Producto;
    idProducto: string = '0';
    formProducto!: FormGroup;
    activo: boolean = true;

    // para manejo del modal de confirmación al desactivar
    showConfirmDialog: boolean = false;
    motivo: string = '';
    motivoMaxLength: number = 200;

    constructor(
        private activedRoute: ActivatedRoute,
        private messageService: MessageService,
        private fb: FormBuilder,
        private router: Router,
        private administradorService: AdministradorService) {
        this.idProducto = this.activedRoute.snapshot.params['id'];
        this.getProducto(this.idProducto);

    }

    getProducto(id: string): void {
        this.administradorService.getProducto(id)
            .subscribe({
                next: (resp) => {
                    this.producto = resp.datos;
                    this.showSuccess(resp.mensaje);
                    this.activo = this.producto.status == 1;
                    console.log(this.producto);
                },
                error: (err: HttpErrorResponse) => { console.log(err) }
            })
    }

    createForm(): FormGroup {
        return this.fb.group({
            codigo: [],
            fk_tipoProducto: [],
            nomProducto: [],
            lote: [],
            caducidad: [],
            noBatch: []
        });
    }

    showSuccess(mensaje: string): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: mensaje
        });
    }

    showError(mensaje: string): void {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: mensaje
        });
    }

    /**
     * Maneja el cambio del inputSwitch.
     * Si se desactiva (activo=false) se muestra un modal para capturar el motivo (máx 200 caracteres).
     * Si se activa, realiza la petición directamente.
     * Se espera que el evento provenga de PrimeNG inputSwitch y tenga la forma { checked: boolean }
     */
    activardesactivar(event: any): void {
        const newState: boolean = event && typeof event.checked !== 'undefined' ? event.checked : this.activo;

        if (!newState) {
            // Se está desactivando: abrir modal para pedir motivo
            this.motivo = '';
            this.showConfirmDialog = true;
            // mantener el valor en el toggle (ya se actualizó por ngModel)
            this.activo = newState;
        } else {
            // Se está activando: actualizar sin mostrar modal
            this.activo = newState;
            this.updateStatus(1, '');
        }
    }

    // Confirmar la desactivación, validar motivo y realizar la petición
    confirmDesactivar(): void {
        const trimmed = (this.motivo || '').trim();
        if (trimmed.length === 0) {
            this.showError('Ingrese el motivo de la desactivación.');
            return;
        }
        if (trimmed.length > this.motivoMaxLength) {
            this.showError(`El motivo no puede exceder ${this.motivoMaxLength} caracteres.`);
            return;
        }

        this.showConfirmDialog = false;
        // Enviar también el motivo al backend
        this.updateStatus(0, trimmed);
    }

    // Cancelar la desactivación: cerrar modal y revertir el toggle al estado activo
    cancelDesactivar(): void {
        this.showConfirmDialog = false;
        // revertir al estado activo (true)
        this.activo = true;
    }

    // Función que realiza la petición de actualización de estado
    private updateStatus(status: number, motivo?: string): void {
        this.administradorService
            .updateProducto(this.idProducto, status, motivo)
            .subscribe({
                next: (resp) => {
                    this.producto.status = resp.datos.status;
                    this.producto.motivo = resp.datos.motivo;
                    this.showSuccess(resp.mensaje);
                }, error: (err: HttpErrorResponse) => {
                    console.log(err.message);
                    this.showError('No se pudo actualizar el estado del producto.');
                }
            });
    }
}
